function WarrantyServicePage(props) {
  return (
    <div>
      <h1>AS 센터</h1>
    </div>
  );
}

export default WarrantyServicePage;
